import React from 'react'
import Style from '../details.module.css'

const TokenDialog = ({
    isOpen,
    token,
    hasToken,
    isLoading,
    isGenerating,
    isDeleting,
    isConfirmingDelete,
    onClose,
    onCopy,
    onRequestDelete,
    onCancelDelete,
    onConfirmDelete,
    onGenerate
}) => {
    if (!isOpen) {
        return null
    }

    return (
        <div className={Style.dialogOverlay} role="dialog" aria-modal="true" aria-label="Refresh token">
            <div className={Style.dialog}>
                <div className={Style.dialogHeader}>
                    <span className={Style.dialogIcon}><i className="uil-key-skeleton" aria-hidden="true" /></span>
                    <div>
                        <h3 className={Style.dialogTitle}>Refresh Token</h3>
                        <p className={Style.dialogSubtitle}>Used to authorize this client against the API.</p>
                    </div>
                    <button type="button" className={Style.dialogClose} aria-label="Close" onClick={onClose}>
                        &times;
                    </button>
                </div>

                <div className={Style.dialogBody}>
                    {isLoading ? (
                        <div className={Style.dialogLoading}>
                            <span className={Style.spinner} aria-hidden="true" />
                            <span>Loading token...</span>
                        </div>
                    ) : hasToken ? (
                        <textarea
                            className={Style.tokenBox}
                            rows="8"
                            readOnly
                            value={token}
                            onFocus={(event) => event.target.select()}
                        />
                    ) : (
                        <div className={Style.emptyState}>
                            <i className={`uil-key-skeleton ${Style.emptyIcon}`} aria-hidden="true" />
                            <p className={Style.emptyText}>No token yet</p>
                            <p className={Style.emptyHint}>Generate one to authorize this client.</p>
                        </div>
                    )}

                    {isConfirmingDelete ? (
                        <div className={Style.confirmBar} role="alert">
                            <i className="uil-exclamation-triangle" aria-hidden="true" />
                            <span className={Style.confirmText}>
                                Delete this token? Anything using it stops working immediately.
                            </span>
                            <button type="button" className={Style.ghostButton} onClick={onCancelDelete}>
                                Cancel
                            </button>
                            <button
                                type="button"
                                className={Style.dangerButton}
                                disabled={isDeleting}
                                onClick={onConfirmDelete}
                            >
                                {isDeleting ? 'Deleting...' : 'Yes, delete'}
                            </button>
                        </div>
                    ) : null}
                </div>

                <div className={Style.dialogFooter}>
                    {!isLoading && hasToken && !isConfirmingDelete ? (
                        <>
                            <button type="button" className={Style.primaryButton} onClick={onCopy}>
                                <i className="uil-copy" aria-hidden="true" /> Copy Token
                            </button>
                            <button type="button" className={Style.dangerButton} onClick={onRequestDelete}>
                                <i className="uil-trash-alt" aria-hidden="true" /> Delete Token
                            </button>
                        </>
                    ) : null}

                    {!isLoading && !hasToken ? (
                        <button
                            type="button"
                            className={Style.primaryButton}
                            disabled={isGenerating}
                            onClick={onGenerate}
                        >
                            {isGenerating ? <span className={Style.buttonSpinner} aria-hidden="true" /> : null}
                            {isGenerating ? 'Waiting for authorization...' : 'Generate Token'}
                        </button>
                    ) : null}

                    <button type="button" className={`${Style.ghostButton} ${Style.footerEnd}`} onClick={onClose}>
                        Close
                    </button>
                </div>
            </div>
        </div>
    )
}

export default TokenDialog
